import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceArticlesViewArticleRoute: InvariantJiraRoute = {
	name: 'csm-experience-articles-view-article',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/articles/:articleId',
	exact: true,
};
